module.exports = __webpack_public_path__ + "img/art.3e5c4282.svg";